/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Reason_From_PurchaseInputs */

const vi_product_lot_history_reason_from_purchase = /** @type {(inputs: Product_Lot_History_Reason_From_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ đơn mua`)
};

/**

* @param {Product_Lot_History_Reason_From_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_reason_from_purchase = /** @type {((inputs?: Product_Lot_History_Reason_From_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Reason_From_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_reason_from_purchase(inputs)
});